<template lang="pug">
  .sidenav(:class="{'is-open': isSidenavOpen, 'is-close': isSidenavClose}")
    .sidenav-background.d-lg-none(v-if="isSidenavOpen", @click="toggleSidenav('sidenav-background', 'open', false)")
    NavigationMenu
</template>

<script>
import { createNamespacedHelpers, mapGetters } from 'vuex'
import NavigationMenu from './NavigationMenu.vue'
//import KonverzaMenu from './KonverzaMenu.vue'

import { EventBus } from '@/helpers/eventBus'

const organizationController = createNamespacedHelpers('organization')
const accountController = createNamespacedHelpers('account')

export default {
  data () {
    return {
      roleType: ''
    }
  },
  computed: {
    roleMenu () {
      if ( (new RegExp('^(konverza-user|konverza-partner)', 'i')).test(this.roleType) ) {
        return 'KonverzaMenu'
      } else {
        return 'NavigationMenu'
      }
    },
    ...organizationController.mapState({
      plugins: state => state.plugins
    }),
    ...accountController.mapState({
      account: state => state.account
    }),
    ...organizationController.mapGetters(['parsedPlugins']),
  },
  components: {
    NavigationMenu,
    //KonverzaMenu
  },
  watch: {
    '$route' (to, from) {
      this.toggleSidenav('sidenav-route-changed', 'open', false)
    }
  },
  created () {
    let user = this.getCurrentUser()
    this.roleType = user.role_type
    EventBus.$on('plugins:check', this.checkPlugins)
  },
  beforeDestroy () {
    EventBus.$off('plugins:check')
    this.$store.commit('organization/setPlugins', [])
  },
  methods: {
    checkPlugins () {
      let plugin = 'Inbox'

      if (this.parsedPlugins.length) {
        // if is konverza type check role and/or account type
        let isKonverza = (new RegExp('^konverza-', 'i')).test(this.roleType)
        let isPartner = (new RegExp('^konverza-partner', 'i')).test(this.roleType)
        if (isKonverza) {
          // if (isPartner) {
          //   if (!this.$getCookie(`account_${this.account.account_id}_tutorial`)) {
          //       return this.$router.push({name: 'First Steps'})
          //   } else {
          //     plugin = 'Training'
          //   }
          // } else {
          //   let accountType = this.account.type
          //   let isEcommerce = (new RegExp('^konverza-ecommerce', 'i')).test(accountType)
          //   let isLeads = (new RegExp('^konverza-leads', 'i')).test(accountType)
          //   if (!this.$getCookie(`account_${this.account.account_id}_tutorial`)) {
          //     return this.$router.push({name: 'First Steps'})
          //     // plugin = 'First Steps'
          //   } else {
          //     if (isEcommerce) {
          //       plugin = 'Orders'
          //     } else if (isLeads) {
          //       plugin = 'Inbox'
          //     }
          //   }
          // }
          let accountType = this.account.type
          let isEcommerce = (new RegExp('^konverza-ecommerce', 'i')).test(accountType)
          let isLeads = (new RegExp('^konverza-leads', 'i')).test(accountType)
          if (!this.$getCookie(`account_${this.account.account_id}_tutorial`)) {
            return this.$router.push({name: 'First Steps'})
            // plugin = 'First Steps'
          } else {
            if (isEcommerce) {
              plugin = 'Orders'
            } else if (isLeads) {
              plugin = 'Inbox'
            }
          }
        }        

        // if is konverza type, a defualt plugin should be loaded
        if (plugin != undefined) {
          let foundPlugin = this.parsedPlugins.find(p => p.name == plugin)
          if (foundPlugin && this.$can('read', foundPlugin.resource_name)) {
            this.$router.push({name: foundPlugin.name, params: foundPlugin.params || {}}).catch(()=>{});
            return
          }
        }

        // if theres no default plugin or error, load first
        for (let i = 0; i < this.parsedPlugins.length; i++) {
          let route = this.parsedPlugins[i]
          if (this.$can('read', route.resource_name)) {
            this.$router.push({name: route.name, params: route.params || {}}).catch(()=>{});
            return
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .sidenav {
    width: 250px;
    overflow-y: auto;
    flex: 0 0 250px;
    border-right: 1px solid #e3ebf6;
    z-index: 10;
    background-color: white;

    position: fixed;
    top: 0;
    bottom: 0;
    left: -250px;
    transition: 0.5s;

    .sidenav-background {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: -5;
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  @media (max-width: 992px) {
    .sidenav {
      &.is-open {
        left: 0 !important;
        display: block !important;
      }
    }
  }

  @media (min-width: 993px) {
    .sidenav {
      left: 0;

      &.is-open {
        left: 0 !important;
      }

      &.is-close {
        left: -250px !important;
      }
    }
  }
</style>
